export default __webpack_public_path__ + "dd3a4fce415a2f1565ee5fad04293fb2.svg";